import React, { useMemo } from 'react'

export default function Widget({
    data,
    className,
    listProperty = 'newsList',
    children
}) {
    const items = useMemo(() => {
        return (
            data?.[listProperty]
                ?.sort((a, b) => a.position - b.position)
                ?.slice(0, data?.limit ?? 1) ?? []
        )
    }, [data, listProperty])

    return (
        <div className={className}>
            {children({ list: items, title: data?.title })}
        </div>
    )
}
